import api from "./api";

export const getHistory = (serial, range) => {

    return api.get(`/stats/history/${serial}?range=${range}`);

};